import type { GravityFormsApiProps } from '@typings'
import { Loop } from '@utilities/helpers/core.helpers'

export const gfTransformPages = (form: GravityFormsApiProps) => {

  const pagination = form.pagination?.pages?.filter(item => item) || []

  return Loop(pagination, (page: string, i: number) => {
    const fields = form.fields.filter(
      (field: any) => field.pageNumber === i + 1
    )

    // todo: any
    const pageFields: any[] = form.fields.filter(({ type }) => type === 'page')
    const nextPage = pageFields.find(f => f.pageNumber === i + 2)
    const prevPage = pageFields.find(f => f.pageNumber === i + 1)

    return {
      pageNumber: i + 1,
      isFirstPage: i === 0,
      isLastPage: pagination?.length - 1 === i,
      title: page,
      fields: fields,
      nextButton: nextPage?.nextButton || null,
      prevButton: prevPage?.previousButton || null,
    }
  })
}
